import * as S from "./styles";

function MenuButton({ label, image, active, action, compact, ...rest }) {
  return (
    <S.Wrapper
      onClick={action}
      active={active}
      compact={compact}
      // Na barra compacta o rótulo some da tela, mas continua disponível no
      // leitor de tela e no toque longo.
      aria-label={label}
      title={compact ? label : undefined}
    >
      {/* <S.Icon src={image} /> */}

      {image}
      <S.Label compact={compact}>{label}</S.Label>
    </S.Wrapper>
  );
}

export default MenuButton;
